import { actions as trackingActions } from 'services/tracking/duck';
import { actions as userActions } from 'services/users/duck';
import { actions as exportActions } from 'services/exports/duck';

// Define an event
const segmentPageView = action => ({
    hitType: 'pageview',
    page: action.payload.page
});
const segmentUserIdentified = action => ({
    hitType: 'identify',
    userId: action.payload.email,
    email: action.payload.email,
    name: action.payload.fullName,
    isOkta: action.payload.isOkta,
    environment: action.getState().config.environment || 'NoEnvironment'
});
const segmentTrackAction = (eventAction, action) => ({
    hitType: 'event',
    eventAction,
    payload: {
        ...action.payload,
        environment: action.getState().config.environment || 'NoEnvironment'
    }
});


// Map the event to a Redux action
const segmentEventsMap = {
    [userActions.FETCH_CURRENT_USER_SUCCESS]: segmentUserIdentified,
    [trackingActions.PAGE_VIEW]: segmentPageView,
    [exportActions.REQUEST_PDF]: action => segmentTrackAction('REQUEST_PDF', action)
};

export default segmentEventsMap;



// WEBPACK FOOTER //
// ./src/tracking/segmentEventMap.js